"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _flat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flat"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("react-bootstrap/lib/Button"));
var _bootstrapUtils = require("react-bootstrap/lib/utils/bootstrapUtils");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Button.scss");
var _excluded = ["className", "bsSize", "flat", "ghost", "loading", "back", "next", "bsStyle"];
(0, _bootstrapUtils.addStyle)(_Button["default"], 'secondary');
(0, _bootstrapUtils.addStyle)(_Button["default"], 'tertiary');
(0, _bootstrapUtils.addStyle)(_Button["default"], 'secondaryNeutral');
(0, _bootstrapUtils.bsSizes)(['xlarge'])(_Button["default"]);
(0, _bootstrapUtils.bsSizes)(['md'])(_Button["default"]);
var Button = function Button(_ref) {
  var className = _ref.className,
    bsSize = _ref.bsSize,
    flat = (0, _flat["default"])(_ref),
    ghost = _ref.ghost,
    loading = _ref.loading,
    back = _ref.back,
    next = _ref.next,
    bsStyle = _ref.bsStyle,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var primaryButtonStyles = ['primary', 'secondary', 'tertiary', 'warning', 'danger', 'success', 'info', 'secondaryNeutral'];
  var isPrimaryButton = (0, _includes["default"])(primaryButtonStyles).call(primaryButtonStyles, bsStyle);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, {
      'btn-flat': flat
    }, {
      'btn-ghost': ghost
    }, {
      'btn-xl': bsSize === 'xlarge'
    }, {
      'btn-loading': loading
    }, {
      'btn-back': back
    }, {
      'btn-next': next
    }, {
      'btn-primary': isPrimaryButton
    }, {
      'btn-link': bsStyle === 'link'
    }, {
      'btn-light': bsStyle === 'light'
    }, {
      'btn-dark': bsStyle === 'dark'
    }, {
      'btn-default-office': bsStyle === 'default-office'
    }, {
      'btn-primary-office': bsStyle === 'primary-office'
    }),
    bsSize: bsSize,
    bsStyle: bsStyle
  }, rest));
};
Button.propTypes = {
  className: _propTypes["default"].string,
  bsSize: _propTypes["default"].string,
  flat: _propTypes["default"].bool,
  ghost: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  back: _propTypes["default"].bool,
  next: _propTypes["default"].bool,
  bsStyle: _propTypes["default"].string
};
Button.defaultProps = {
  className: undefined,
  bsSize: undefined,
  flat: false,
  ghost: false,
  loading: false,
  back: false,
  next: false,
  bsStyle: undefined
};
var _default = exports["default"] = Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Button.js
// module id = 17
// module chunks = 25